export default __webpack_public_path__ + "static/media/fcf-and-profitability-3.b08db579.png";